import { runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { t } from 'react-switch-lang';
import usersStorage from '../../../pages/Users/usersStorage';
import { requestPut } from '../../../services/real.backend';

export default function createUser(data) {
  return requestPut('/api/users', { users: data })
    .then((resp) => {
      runInAction(() => {
        // usersStorage.users
        usersStorage.isUserSaveRequestProgress = false;
        toast.success(t('users.created'));
      });
    })
    .catch((e) => {});
}
